export default __webpack_public_path__ + "static/media/ts.325e9650.png";